import PropTypes from 'prop-types';
import styled from 'helpers/styles';
import ComponentStyles from 'styles/mixins/Component.styles';
import Dialog from 'components/organisms/Dialogs/Dialog/Dialog';

const StyledHostnamesDialog = styled(Dialog)`
  .MuiDialog-paper {
    width: clamp(0px, ${props => props.theme.layout(452)}, 86vw);
  }
  
  .Form {
    .Form-fields {
      .FormField-name-hostnames {
        .ListField-container {
          .ListItem {
            .MuiFormControlLabel-label {
              line-break: anywhere;
            }
          }
        }
      }
    }
  }
  ${ComponentStyles}
`;

StyledHostnamesDialog.propTypes = {
  theme: PropTypes.object
};

export default StyledHostnamesDialog;
